export default "__VITE_ASSET__BNvzxzIX__"